import type {
  OrganizationTreeItem,
  SubClientSummary,
} from "../../clients/types/clients-api.types";

/** Nombre visible en pagos: prioriza first_name + last_name; si faltan, company_name. */
export function paymentClientDisplayName(item: {
  name?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  company_name?: string | null;
}): string {
  const name = item.name?.trim();
  if (name) return name;
  const fn = item.first_name?.trim() ?? "";
  const ln = item.last_name?.trim() ?? "";
  const composed = [fn, ln].filter(Boolean).join(" ");
  if (composed) return composed;
  const company = item.company_name?.trim();
  if (company) return company;
  return "";
}

/** Nombre visible en pagos para la fila raíz (organización): prioriza `name`. */
export function paymentOrganizationTreeLabel(item: OrganizationTreeItem): string {
  const n = item.name?.trim();
  if (n) return n;
  return paymentClientDisplayName(item) || "";
}

export function paymentSubclientDisplayName(sub: SubClientSummary): string {
  return paymentClientDisplayName(sub);
}
